<template>
  <q-dialog v-model="visible" full-height position="right">
    <q-card style="width: 512px">
      <q-toolbar class="horizontal-line">
        <q-toolbar-title v-if="campaignType === 'story'">
          {{ $t('label.story.scenario_sharing_story') }}
        </q-toolbar-title>
        <q-toolbar-title v-else> {{ $t('label.story.usage_story') }} </q-toolbar-title>
        <q-btn flat round dense icon="close" v-close-popup />
      </q-toolbar>
      <CLoading :loading="loading" />
      <q-card-section style="padding: 0 !important">
        <div class="max-height-dialog">
          <div v-for="(story, index) in stories" :key="story.story_id + '-' + index" class="q-pa-sm horizontal-line">
            <a
              :href="getEditUrl(story)"
              @click="onEdit($event, props.row)"
              class="cursor-pointer hyper-link-chart title"
            >
              {{ story.story_name }} </a
            ><br />
            <a
              :href="getDetailsUrl(story)"
              @click="onDetails($event, props.row)"
              class="cursor-pointer hyper-link-chart"
            >
              {{ $t('label.data_transition') }}
            </a>
            <span class="text-caption">
              / {{ story.story_id.length > 4 ? story.story_id.slice(0, 4) + '***' : story.story_id }}</span
            >
            <span class="text-caption"> / {{ $t('label.created_at') }}: {{ story.created_at }}</span>
            <span class="text-caption"> / {{ $t('label.updated_at') }}: {{ story.updated_at }}</span>
          </div>
        </div>
        <div class="row no-wrap items-center q-mt-md q-pr-md">
          <q-space />
          <div class="q-gutter-sm">
            <q-btn flat class="btn-cancel" @click="onCancel">{{ $t('close') }}</q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import CLoading from '@/components/common/ui/CLoading.vue'
import { ACTION_INITIAL, ACTION_PUSH, ACTION_STORY } from '@/store/actions'
import { lastNMonth, now } from '@/utils/datetime'
import { constant } from '@/utils/constants'

@Options({
  components: { CLoading },
  directives: { maska },
  emits: ['update:closeModal'],
})
export default class UsageStoryModal extends Vue {
  @Prop()
  storyId!: string

  @Prop()
  campaignId!: string

  @Prop()
  campaignType!: string

  @Prop()
  modalVisible!: boolean

  loading = false
  stories: {
    app_id: string
    relationship_type: string
    story_id: string
    story_name: string
    created_at: string
    updated_at: string
  }[] = []

  get visible() {
    return this.modalVisible
  }

  set visible(value) {
    this.$emit('update:closeModal', value)
  }

  async fetchStoriesUsing() {
    if (this.campaignType === 'initial') {
      const res = await this.$store.dispatch(ACTION_INITIAL.LOAD_STORIES_USING, this.campaignId)
      this.stories = res.stories
    } else if (this.campaignType === 'push') {
      const res = await this.$store.dispatch(ACTION_PUSH.LOAD_STORIES_USING, this.campaignId)
      this.stories = res.stories
    } else {
      const res = await this.$store.dispatch(ACTION_STORY.CAMPAIGN_USAGE, this.storyId)
      this.stories = res.usage_stories
    }
  }

  getDetailsUrl(data) {
    return this.$router.resolve({
      name: 'story_details',
      params: {
        app_id: data.app_id,
        campaign_type: 'initial',
        story_id: data.story_id,
        from_date: lastNMonth(1),
        to_date: now(),
      },
    }).href
  }

  onDetails(event, data) {
    // Check if Ctrl (Windows) or Meta (Mac) is pressed
    if (event.ctrlKey || event.metaKey) {
      // Let the browser handle opening in a new tab
      return
    }
    // Otherwise, navigate programmatically
    event.preventDefault()

    this.goto('story_details', {
      app_id: data.app_id,
      campaign_type: 'initial',
      story_id: data.story_id,
      from_date: lastNMonth(1),
      to_date: now(),
    })
  }

  getEditUrl(data) {
    return this.$router.resolve({
      name: 'story_setting',
      params: {
        app_id: data.app_id,
        story_id: data.story_id,
        action_type: constant.ACTION_TYPE.EDIT,
      },
    }).href
  }

  onEdit(event, data) {
    // Check if Ctrl (Windows) or Meta (Mac) is pressed
    if (event.ctrlKey || event.metaKey) {
      // Let the browser handle opening in a new tab
      return
    }
    // Otherwise, navigate programmatically
    event.preventDefault()

    this.goto('story_setting', {
      app_id: data.app_id,
      story_id: data.story_id,
      action_type: constant.ACTION_TYPE.EDIT,
    })
  }

  goto(name: string, params = {}) {
    this.$router.push({
      name,
      params,
    })
  }

  onCancel() {
    this.visible = false
  }

  async created() {
    this.loading = true
    await this.fetchStoriesUsing()
    this.loading = false
  }
}
</script>

<style scoped lang="scss">
.hyper-link-chart.title {
  font-size: 16px;
}
</style>
